export default {"src":"/_next/static/media/btnSwap.7208927e.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};